import { render } from "./qrCode.vue?vue&type=template&id=ec3a383c&scoped=true"
const script = {}

import "./qrCode.vue?vue&type=style&index=0&id=ec3a383c&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec3a383c"]])

export default __exports__